<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Əmək haqqından tutulmaların hesablanması</h1>
      </div>

      <div class="col-12">
        <p class="note">1 yanvar 2019-cu il tarixdən başlayaraq 7 il müddətində neft-qaz sahəsində fəaliyyəti olmayan və qeyri-dövlət sektoruna aid edilən vergi ödəyicilərində muzdlu işləyən fiziki şəxslərin aylıq gəlirləri 8 000 manatadək olduqda gəlir vergisi tutulmur, 8 000 manatdan çox olan məbləğin isə 14 faizi tutulur.</p>
      </div>

      <div class="col-md-6">
        <p>"GROSS" aylıq əmək haqqı:</p>
        <input type="number" v-model="gross" @input="calc">
      </div>

      <div class="col-md-6">
        <p>İş kateqoriyası:</p>
        <select v-model="category" @change="calc">
          <option value="dovlet">Büdcə təşkilatları, dövlət şirkətləri və digər vergi ödəyiciləri</option>
          <option value="qeyri">Neft-qaz sahəsində fəaliyyəti olmayan və qeyri-dövlət sektoruna aid edilən vergi ödəyiciləri</option>
        </select>
      </div>

      <div class="col-md-6">
        <p>Gəlir vergisi:</p>
        <input type="text" v-model="incomeTax" disabled>
      </div>
      <div class="col-md-6">
        <p>DSMF:</p>
        <input type="text" v-model="dsmf" disabled>
      </div>
      <div class="col-md-6">
        <p>İşsizlikdən sığorta haqqı:</p>
        <input type="text" v-model="insurance" disabled>
      </div>
      <div class="col-md-6">
        <p>İcbari tibbi sığorta haqqı:</p>
        <input type="text" v-model="tibb" disabled>
      </div>
      <div class="col-md-6">
        <p>Xalis aylıq əmək haqqı (NETT):</p>
        <input type="text" v-model="nett" disabled>
      </div>

      <div class="col-12">
        <div class="note">
          <p>"GROSS" əmək haqqı – vergi ödənişlərindən öncə işçiyə hesablanan əmək haqqı.</p>
          <p>"NETT" əmək haqqı – vergi ödənişlərindən sonra olan əmək haqqı (işçiyə verilən məbləğ).</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script> 
  export default {
    data(){
      return {
        gross: '',
        nett: '0',
        category: 'qeyri',
        incomeTax: '0',
        dsmf: '0',
        insurance: '0',
        tibb: '0'
      }
    },
    methods: {
      calc: function(){

        if( this.category == 'dovlet' ) {

          this.incomeTax = this.gross < 2500 ?
                           ((this.gross - 200) * 0.14).toFixed(2) :
                           (350 + (this.gross - 2500) * 0.25).toFixed(2);

          if(this.incomeTax < 0){ this.incomeTax = 0 };

          this.dsmf = (this.gross * 0.03).toFixed(2);
          this.insurance = (this.gross * 0.005).toFixed(2);

          this.tibb = this.gross > 8000 ?
                      ((8000 * 0.02) + (this.gross - 8000) * 0.005).toFixed(2) :
                      (this.gross * 0.02).toFixed(2);

          this.nett = (this.gross - this.incomeTax - this.dsmf - this.insurance - this.tibb).toFixed(2);

        } else if( this.category == 'qeyri' ) {

          this.incomeTax = this.gross > 8000 ?
                           this.incomeTax = ((this.gross - 8000) * 0.14).toFixed(2) :
                           this.incomeTax = 0;

          this.dsmf = this.gross < 200 ? 
                        (this.gross * 0.03).toFixed(2) : 
                        ((6 + ((this.gross - 200) * 0.1))).toFixed(2);

          this.insurance = (this.gross * 0.005).toFixed(2);
          
          this.tibb = this.gross > 8000 ?
                      ((8000 * 0.01) + (this.gross - 8000) * 0.005).toFixed(2) :
                      (this.gross * 0.01).toFixed(2);

          this.nett = (this.gross - this.incomeTax - this.dsmf - this.insurance - this.tibb).toFixed(2);

        }

      }
    }
  }
</script>

<style scoped>


</style>


// WEBPACK FOOTER //
// src/components/calc/Salary.vue